<div
  class="animated-sprite"
  [style.--frames]="frames()"
  [style.--position]="assetOffsetY()"
  [style.--frame-duration]="totalAnimationDuration()"
>
  <div
    class="sprite-strip"
    [style.background-image]="'url(\'' + assetUrl() + '\')'"
  ></div>
</div>
